// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes swing {
  0%, 30%, 50%, 70%, 100% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-5deg);
  }
}
.pro-sidebar {
  color: #ffffff;
  height: 100%;
  width: 256px;
  min-width: 256px;
  text-align: left;
  transition: width, left, right, 0.3s;
  position: relative;
  z-index: 1009;
}
.pro-sidebar > .pro-sidebar-inner {
  background: var(--primary-green);
  height: 100%;
  position: relative;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > img.sidebar-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  opacity: 0.3;
  left: 0;
  top: 0;
  z-index: 100;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-content {
  flex-grow: 1;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.pro-sidebar .overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: none;
}
.pro-sidebar.collapsed {
  width: 72px;
  min-width: 72px;
}
.pro-sidebar.rtl {
  text-align: right;
  direction: rtl;
}
@media (max-width: 480px) {
  .pro-sidebar.xs {
    position: fixed;
    left: -256px;
  }
  .pro-sidebar.xs.collapsed {
    left: -72px;
  }
  .pro-sidebar.xs.toggled {
    left: 0;
  }
  .pro-sidebar.xs.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xs.rtl {
    left: auto;
    right: -256px;
  }
  .pro-sidebar.xs.rtl.collapsed {
    left: auto;
    right: -72px;
  }
  .pro-sidebar.xs.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 576px) {
  .pro-sidebar.sm {
    position: fixed;
    left: -256px;
  }
  .pro-sidebar.sm.collapsed {
    left: -72px;
  }
  .pro-sidebar.sm.toggled {
    left: 0;
  }
  .pro-sidebar.sm.toggled .overlay {
    display: block;
  }
  .pro-sidebar.sm.rtl {
    left: auto;
    right: -256px;
  }
  .pro-sidebar.sm.rtl.collapsed {
    left: auto;
    right: -72px;
  }
  .pro-sidebar.sm.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 768px) {
  .pro-sidebar.md {
    position: fixed;
    left: -256px;
  }
  .pro-sidebar.md.collapsed {
    left: -72px;
  }
  .pro-sidebar.md.toggled {
    left: 0;
  }
  .pro-sidebar.md.toggled .overlay {
    display: block;
  }
  .pro-sidebar.md.rtl {
    left: auto;
    right: -256px;
  }
  .pro-sidebar.md.rtl.collapsed {
    left: auto;
    right: -72px;
  }
  .pro-sidebar.md.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 992px) {
  .pro-sidebar.lg {
    position: fixed;
    left: -256px;
  }
  .pro-sidebar.lg.collapsed {
    left: -72px;
  }
  .pro-sidebar.lg.toggled {
    left: 0;
  }
  .pro-sidebar.lg.toggled .overlay {
    display: block;
  }
  .pro-sidebar.lg.rtl {
    left: auto;
    right: -256px;
  }
  .pro-sidebar.lg.rtl.collapsed {
    left: auto;
    right: -72px;
  }
  .pro-sidebar.lg.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1200px) {
  .pro-sidebar.xl {
    position: fixed;
    left: -256px;
  }
  .pro-sidebar.xl.collapsed {
    left: -72px;
  }
  .pro-sidebar.xl.toggled {
    left: 0;
  }
  .pro-sidebar.xl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xl.rtl {
    left: auto;
    right: -256px;
  }
  .pro-sidebar.xl.rtl.collapsed {
    left: auto;
    right: -72px;
  }
  .pro-sidebar.xl.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1600px) {
  .pro-sidebar.xxl {
    position: fixed;
    left: -256px;
  }
  .pro-sidebar.xxl.collapsed {
    left: -72px;
  }
  .pro-sidebar.xxl.toggled {
    left: 0;
  }
  .pro-sidebar.xxl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xxl.rtl {
    left: auto;
    right: -256px;
  }
  .pro-sidebar.xxl.rtl.collapsed {
    left: auto;
    right: -72px;
  }
  .pro-sidebar.xxl.rtl.toggled {
    left: auto;
    right: 0;
  }
}

.pro-sidebar .pro-menu.submenu-bullets .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  content: "";
  display: inline-block;
  width: 4px;
  min-width: 4px;
  height: 4px;
  border: 1px solid #60a0ff;
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
  box-shadow: 1px 0px 0px #ffffff, 0px -1px 0px #ffffff, 0px 1px 0px #ffffff, -1px 0px 0px #ffffff;
}

.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pro-sidebar .pro-menu {
  padding-top: 10px;
  padding-bottom: 10px;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
  position: relative;
  background-color: #60a0ff;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item > div > ul {
  padding-top: 15px;
  padding-bottom: 15px;
}
.pro-sidebar .pro-menu a {
  text-decoration: none;
  color: #ffffff;
}
.pro-sidebar .pro-menu a:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
}
.pro-sidebar .pro-menu a:hover {
  color: #ffffff;
}
.pro-sidebar .pro-menu .pro-menu-item {
  font-size: 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.active {
  color: #ffffff;
}
.pro-sidebar .pro-menu .pro-menu-item .suffix-wrapper {
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item .prefix-wrapper {
  display: flex;
  margin-right: 5px;
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 35px 8px 20px;
  cursor: pointer;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:focus {
  outline: none;
  color: #ffffff;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 10px;
  font-size: 14px;
  width: 24px;
  min-width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  display: inline-block;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper .pro-icon {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  flex-grow: 1;
  flex-shrink: 1;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {
  color: #ffffff;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item:before {
  background: #ffffff;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  display: inline-block;
  border-style: solid;
  border-color: #ffffff;
  border-width: 0 2px 2px 0;
  padding: 2.5px;
  vertical-align: middle;
  transition: transform 0.3s;
  transform: rotate(-45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item:before {
  background: transparent !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 24px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item > .pro-icon-wrapper {
  background: none;
  width: auto;
  min-width: auto;
  height: auto;
  line-height: auto;
}
.pro-sidebar .pro-menu:not(.inner-submenu-arrows) .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar .pro-menu.shaped .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  background-color: rgba(255, 255, 255, 0.05);
}
.pro-sidebar .pro-menu.square .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 0;
}
.pro-sidebar .pro-menu.round .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 4px;
}
.pro-sidebar .pro-menu.circle .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 50%;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .suffix-wrapper,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .prefix-wrapper {
  opacity: 0;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-list-item {
  background-color: #60a0ff;
  z-index: 111;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item {
  pointer-events: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  height: auto !important;
  position: fixed;
  visibility: hidden;
  min-width: 220px;
  max-width: 270px;
  background-color: transparent;
  max-height: 100%;
  padding-left: 3px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-left: 10px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  max-height: 100vh;
  overflow-y: auto;
  background-color: #60a0ff;
  padding-left: 20px;
  border-radius: 4px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover > .pro-inner-list-item {
  transition: visibility, transform 0.3s;
  visibility: visible;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item .prefix-wrapper {
  margin-right: 0;
  margin-left: 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item {
  padding: 8px 20px 8px 35px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 0;
  margin-left: 10px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  right: auto;
  left: 20px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(135deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 0;
  padding-right: 24px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 15px 8px 30px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  margin-right: 0;
  margin-left: 15px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  padding-left: 0;
  padding-right: 3px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-right: 10px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  padding-left: 0;
  padding-right: 20px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 5px 8px 30px;
}

.popper-arrow {
  position: absolute;
  z-index: -1;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.popper-element[data-popper-placement^=left] > .popper-arrow {
  right: 0;
  border-right: 7px solid #60a0ff;
}

.popper-element[data-popper-placement^=right] > .popper-arrow {
  left: 0;
  border-left: 7px solid #60a0ff;
}

.react-slidedown {
  height: 0;
  transition-property: none;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}

.react-slidedown.transitioning {
  overflow-y: hidden;
}

.react-slidedown.closed {
  display: none;
}

.app {
  height: 100vh;
  display: flex;
  position: relative;
}
.app .hamburguer {
  margin-bottom: 0.5rem;
}
.app .logout {
  cursor: pointer;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16.8px;
  color: var(--white);
}
.app .pro-sidebar {
  height: auto;
}
.app .pro-sidebar .pro-menu:hover {
  background-color: #60a0ff !important;
}
.app .pro-sidebar .pro-menu:hover .pro-icon-wrapper .pro-icon {
  animation: none !important;
}
.app .pro-sidebar .pro-sidebar-inner .pro-sidebar-layout .pro-sidebar-header {
  border-bottom: none;
}
.app .pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-footer {
  border-top: none;
}
.app .hr-sidebar {
  border: 1px solid var(--white);
  width: 90%;
}
.app .dashboardContainer {
  display: flex;
  background: linear-gradient(var(--white-1), var(--white-1), rgba(0, 0, 0, 0.1));
}
.app .dashboard {
  height: auto;
  display: flex;
  background: linear-gradient(var(--white-1), var(--white-1), rgba(0, 0, 0, 0.1));
}
.app .homeSection {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: opacityMotion ease-out 0.5s;
}
.app .sidebar-version {
  font-family: Inter;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: var(--white);
}
@keyframes opacityMotion {
  0% {
    opacity: 0%;
  }
  100% {
    opacity: 100%;
  }
}
.app .pro-sidebar .pro-menu .pro-menu-item {
  font-size: 16.8px;
  color: var(--white);
}
.app .sidebar-title {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  color: var(--white);
  margin-left: 1rem;
}
.app .btn-toggle {
  cursor: pointer;
  width: 35px;
  height: 35px;
  background: #353535;
  color: #ffffff;
  text-align: center;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  display: none;
}
.app .sidebar-btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.app .sidebar-btn-wrapper .sidebar-btn {
  transition: width 0.3s;
  width: 150px;
  padding: 1px 15px;
  border-radius: 40px;
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  text-decoration: none;
  margin: 0 auto;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
}
.app .sidebar-btn-wrapper .sidebar-btn span {
  margin-left: 5px;
  font-size: 13px;
}
.app .sidebar-btn-wrapper .sidebar-btn:hover {
  color: #ffffff;
}
.app .collapsed .pro-menu-item:hover {
  background-color: #0064f8;
}
.app .collapsed .pro-menu-item:hover .pro-icon-wrapper .pro-icon {
  animation: none !important;
}
.app .collapsed .sidebar-btn {
  display: inline-block;
  line-height: 40px;
  padding: 0;
}
.app .collapsed .sidebar-title {
  display: none !important;
}
.app .collapsed .sidebar-user-label {
  display: none;
}
.app main {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100vh;
}
.app main header {
  margin-top: 40px;
  border-bottom: 1px solid #efefef;
}
.app main header h1 {
  display: flex;
  align-items: center;
  transform: translateX(-20px);
}
.app main footer {
  margin-top: auto;
  color: #888;
  text-align: center;
}
.app main footer a {
  text-decoration: none;
  color: #888;
}
.app main footer a:hover {
  text-decoration: underline;
}
.app .social-bagdes {
  margin-top: 10px;
}
.app .social-bagdes img {
  margin: 5px;
}
.app .block {
  display: flex;
  margin-bottom: 24px;
  font-size: 14px;
  color: #545454;
}
.app .block > span {
  margin-left: 10px;
}
.app.rtl {
  direction: rtl;
  text-align: right;
}
.app.rtl header h1 {
  transform: translateX(20px);
}
.app.rtl .block {
  direction: rtl;
}
.app.rtl .block > span {
  margin-left: 0;
  margin-right: 10px;
}
.app.rtl .sidebar-btn-wrapper .sidebar-btn span {
  margin-left: 0;
  margin-right: 5px;
}
@media (max-width: 767.98px) {
  .app {
    overflow-x: hidden;
  }
  .app header h1 {
    font-size: 24px;
  }
}
@media (max-width: 768px) {
  .app .pro-sidebar.md.collapsed {
    left: 0;
  }
  .app .pro-sidebar.md {
    left: 0;
    position: relative;
  }
}

.badge {
  padding: 3px 6px;
  font-size: 9px;
  letter-spacing: 1px;
  border-radius: 15px;
}
.badge.red {
  color: #ffffff;
  background: #d63030;
}
.badge.gray {
  color: #ffffff;
  background: #777777;
}
.badge.yellow {
  color: #000000;
  background: #ffd331;
}

.tooltip {
  background-color: #60a0ff;
  opacity: 1 !important;
  font-weight: 500 !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_animation.scss","webpack://./src/components/sidebar/Sidebar.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_sidebar.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_menu.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/variables.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_popperArrow.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_reactSlidedown.scss"],"names":[],"mappings":"AAAA;EACE;IAKE,uBAAA;ECFF;EDKA;IACE,wBAAA;ECHF;EDMA;IACE,yBAAA;ECJF;EDOA;IACE,uBAAA;ECLF;EDQA;IACE,wBAAA;ECNF;AACF;ACSA;EACE,cDtBc;ECuBd,YAAA;EACA,YDnBc;ECoBd,gBDpBc;ECqBd,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;ADPF;ACQE;EACE,gCDlCe;ECmCf,YAAA;EACA,kBAAA;EACA,YAAA;ADNJ;ACQI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;ADNN;ACSI;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;ADPN;ACSM;EACE,iDAAA;ADPR;ACSM;EACE,YAAA;ADPR;ACSM;EACE,8CAAA;ADPR;ACSM;EACE,qBAAA;EACA,UAAA;EACA,SAAA;ADPR;ACYE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;ADVJ;ACaE;EACE,WDlFsB;ECmFtB,eDnFsB;AAwE1B;ACcE;EACE,iBAAA;EACA,cAAA;ADZJ;ACgBI;EADF;IAnGA,eAAA;IACA,YAAA;EDwFA;ECvFA;IACE,WAAA;EDyFF;ECvFA;IACE,OAAA;EDyFF;ECxFE;IACE,cAAA;ED0FJ;ECvFA;IACE,UAAA;IACA,aAAA;EDyFF;ECxFE;IACE,UAAA;IACA,YAAA;ED0FJ;ECxFE;IACE,UAAA;IACA,QAAA;ED0FJ;AACF;ACNI;EADF;IAxGA,eAAA;IACA,YAAA;EDmHA;EClHA;IACE,WAAA;EDoHF;EClHA;IACE,OAAA;EDoHF;ECnHE;IACE,cAAA;EDqHJ;EClHA;IACE,UAAA;IACA,aAAA;EDoHF;ECnHE;IACE,UAAA;IACA,YAAA;EDqHJ;ECnHE;IACE,UAAA;IACA,QAAA;EDqHJ;AACF;AC5BI;EADF;IA7GA,eAAA;IACA,YAAA;ED8IA;EC7IA;IACE,WAAA;ED+IF;EC7IA;IACE,OAAA;ED+IF;EC9IE;IACE,cAAA;EDgJJ;EC7IA;IACE,UAAA;IACA,aAAA;ED+IF;EC9IE;IACE,UAAA;IACA,YAAA;EDgJJ;EC9IE;IACE,UAAA;IACA,QAAA;EDgJJ;AACF;AClDI;EADF;IAlHA,eAAA;IACA,YAAA;EDyKA;ECxKA;IACE,WAAA;ED0KF;ECxKA;IACE,OAAA;ED0KF;ECzKE;IACE,cAAA;ED2KJ;ECxKA;IACE,UAAA;IACA,aAAA;ED0KF;ECzKE;IACE,UAAA;IACA,YAAA;ED2KJ;ECzKE;IACE,UAAA;IACA,QAAA;ED2KJ;AACF;ACxEI;EADF;IAvHA,eAAA;IACA,YAAA;EDoMA;ECnMA;IACE,WAAA;EDqMF;ECnMA;IACE,OAAA;EDqMF;ECpME;IACE,cAAA;EDsMJ;ECnMA;IACE,UAAA;IACA,aAAA;EDqMF;ECpME;IACE,UAAA;IACA,YAAA;EDsMJ;ECpME;IACE,UAAA;IACA,QAAA;EDsMJ;AACF;AC9FI;EADF;IA5HA,eAAA;IACA,YAAA;ED+NA;EC9NA;IACE,WAAA;EDgOF;EC9NA;IACE,OAAA;EDgOF;EC/NE;IACE,cAAA;EDiOJ;EC9NA;IACE,UAAA;IACA,aAAA;EDgOF;EC/NE;IACE,UAAA;IACA,YAAA;EDiOJ;EC/NE;IACE,UAAA;IACA,QAAA;EDiOJ;AACF;;AEtPE;EACE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gGAAA;AFyPJ;;AEpPA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AFuPF;;AEnPE;EACE,iBAAA;EACA,oBAAA;AFsPJ;AElPQ;EACE,kBAAA;EACA,yBF5BS;AAgRnB;AElPU;EACE,iBAAA;EACA,oBAAA;AFoPZ;AE/OI;EACE,qBAAA;EACA,cFrCU;AAsRhB;AEhPM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;AFkPR;AEhPM;EACE,cF/CU;AAiSlB;AE/OI;EACE,eAAA;AFiPN;AEhPM;EACE,cFrDU;AAuSlB;AE/OM;EACE,UAAA;EACA,wBAAA;AFiPR;AE/OM;EACE,aAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;AFiPR;AE9OM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AFgPR;AE9OQ;EACE,aAAA;EACA,cF5EQ;AA4TlB;AE9OQ;EACE,kBAAA;EACA,eAAA;EACA,WF/EE;EEgFF,eFhFE;EEiFF,YFjFE;EEkFF,iBFlFE;EEmFF,kBAAA;EACA,qBAAA;AFgPV;AE9OU;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AFgPZ;AE5OQ;EACE,YAAA;EACA,cAAA;AF8OV;AEzOQ;EACE,cFxGQ;AAmVlB;AEzOY;EACE,6CAAA;AF2Od;AEnOU;EACE,mBFrHI;AA0VhB;AElOU;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AFoOZ;AElOY;EACE,qBAAA;EACA,mBAAA;EACA,qBFjIE;EEkIF,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AFoOd;AE7NY;EACE,kCAAA;AF+Nd;AE5Nc;EACE,wBAAA;AF8NhB;AExNQ;EACE,kBCrJO;AH+WjB;AExNU;EACE,0BAAA;AF0NZ;AExNY;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AF0Nd;AElNM;EACE,aAAA;AFoNR;AExMU;EACE,2CFvLI;AAiYhB;AEjMU;EACE,gBAAA;AFmMZ;AE3LU;EACE,kBAAA;AF6LZ;AErLU;EACE,kBAAA;AFuLZ;AEzKY;;EAEE,UAAA;AF2Kd;AExKU;EACE,yBF1OiB;EE2OjB,YAAA;AF0KZ;AEnLQ;EAWE,kBAAA;AF2KV;AE1KU;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AF4KZ;AE1KU;EACE,kBAAA;AF4KZ;AE1KY;EACE,oBAAA;AF4Kd;AE1Kc;EACE,aAAA;AF4KhB;AEzKY;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AF2Kd;AE1Kc;EACE,kBAAA;AF4KhB;AE1Kc;EACE,iBAAA;EACA,gBAAA;EACA,yBFjRa;EEkRb,kBAAA;EACA,kBAAA;AF4KhB;AExKc;EACE,sCAAA;EACA,mBAAA;AF0KhB;AEvKgB;EACE,6CAAA;AFyKlB;AEnKc;;EAEE,yBAAA;AFqKhB;AExJQ;EACE,eAAA;EACA,gBAAA;AF0JV;AExJQ;EACE,0BAAA;AF0JV;AEzJU;EACE,eAAA;EACA,iBAAA;AF2JZ;AErJY;EACE,WAAA;EACA,UAAA;AFuJd;AEtJc;EACE,yBAAA;AFwJhB;AEjJgB;EACE,wBAAA;AFmJlB;AE7IU;EACE,eAAA;EACA,mBC/UK;AH8djB;AE7IY;EACE,0BAAA;AF+Id;AE9Ic;EACE,eAAA;EACA,iBAAA;AFgJhB;AElIc;EACE,eAAA;EACA,kBAAA;AFoIhB;AEnIgB;EACE,mBAAA;AFqIlB;AEnIgB;EACE,eAAA;EACA,mBAAA;AFqIlB;AEhIgB;;EAEE,yBAAA;AFkIlB;;AI7fA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;AJggBF;;AI7fA;EACE,QAAA;EACA,+BAAA;AJggBF;;AI7fA;EACE,OAAA;EACA,8BAAA;AJggBF;;AKhhBA;EACE,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,uCAAA;ALmhBF;;AKhhBA;EACE,kBAAA;ALmhBF;;AKhhBA;EACE,aAAA;ALmhBF;;AAjhBA;EACE,aAAA;EACA,aAAA;EACA,kBAAA;AAohBF;AAlhBE;EACE,qBAAA;AAohBJ;AAjhBE;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAmhBJ;AAhhBE;EACE,YAAA;AAkhBJ;AA/gBM;EACE,oCAAA;AAihBR;AA/gBU;EACE,0BAAA;AAihBZ;AA1gBQ;EACE,mBAAA;AA4gBV;AAtgBE;EACE,gBAAA;AAwgBJ;AAtgBE;EACE,8BAAA;EACA,UAAA;AAwgBJ;AArgBE;EACE,aAAA;EACA,+EAAA;AAugBJ;AApgBE;EACE,YAAA;EACA,aAAA;EACA,+EAAA;AAsgBJ;AAngBE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sCAAA;AAqgBJ;AAlgBE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAogBJ;AAjgBE;EACE;IACE,WAAA;EAmgBJ;EAjgBE;IACE,aAAA;EAmgBJ;AACF;AAhgBE;EACE,iBAAA;EACA,mBAAA;AAkgBJ;AAhgBE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAkgBJ;AA/fE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;AAigBJ;AA9fE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAggBJ;AA/fI;EACE,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;AAigBN;AAhgBM;EACE,gBAAA;EACA,eAAA;AAkgBR;AAhgBM;EACE,cAnJU;AAqpBlB;AA3fM;EACE,yBAAA;AA6fR;AA3fU;EACE,0BAAA;AA6fZ;AAxfI;EACE,qBAAA;EACA,iBAAA;EACA,UAAA;AA0fN;AAxfI;EACE,wBAAA;AA0fN;AAxfI;EACE,aAAA;AA0fN;AAtfE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AAwfJ;AAvfI;EACE,gBAAA;EACA,gCAAA;AAyfN;AAxfM;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;AA0fR;AAtfI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AAwfN;AAvfM;EACE,qBAAA;EACA,WAAA;AAyfR;AAxfQ;EACE,0BAAA;AA0fV;AArfE;EACE,gBAAA;AAufJ;AAtfI;EACE,WAAA;AAwfN;AApfE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAsfJ;AArfI;EACE,iBAAA;AAufN;AAnfE;EACE,cAAA;EACA,iBAAA;AAqfJ;AAlfM;EACE,2BAAA;AAofR;AAjfI;EACE,cAAA;AAmfN;AAlfM;EACE,cAAA;EACA,kBAAA;AAofR;AA/eQ;EACE,cAAA;EACA,iBAAA;AAifV;AA3eE;EAhPF;IAiPI,kBAAA;EA8eF;EA5eI;IACE,eAAA;EA8eN;AACF;AA1eE;EACE;IACE,OAAA;EA4eJ;EA1eE;IACE,OAAA;IACA,kBAAA;EA4eJ;AACF;;AArdA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAwdF;AAvdE;EACE,cAAA;EACA,mBAAA;AAydJ;AAvdE;EACE,cAAA;EACA,mBAAA;AAydJ;AAvdE;EACE,cAAA;EACA,mBAAA;AAydJ;;AArdA;EACE,yBAtTiB;EAuTjB,qBAAA;EACA,2BAAA;AAwdF","sourcesContent":["@keyframes swing {\n  0%,\n  30%,\n  50%,\n  70%,\n  100% {\n    transform: rotate(0deg);\n  }\n\n  10% {\n    transform: rotate(10deg);\n  }\n\n  40% {\n    transform: rotate(-10deg);\n  }\n\n  60% {\n    transform: rotate(5deg);\n  }\n\n  80% {\n    transform: rotate(-5deg);\n  }\n}\n","@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');\r\n\r\n$sidebar-bg-color: var(--primary-green);\r\n$submenu-bg-color: #60a0ff;\r\n$submenu-bg-color-collapsed: #60a0ff;\r\n$sidebar-color: #ffffff;\r\n$highlight-color: #ffffff;\r\n$icon-bg-color: rgba(255, 255, 255, 0.05);\r\n$icon-size: 24px;\r\n$sidebar-collapsed-width: 72px !default;\r\n$sidebar-width: 256px !default;\r\n\r\n@import '~react-pro-sidebar/dist/scss/styles.scss';\r\n\r\n.app {\r\n  height: 100vh;\r\n  display: flex;\r\n  position: relative;\r\n\r\n  .hamburguer {\r\n    margin-bottom: 0.5rem;\r\n  }\r\n\r\n  .logout {\r\n    cursor: pointer;\r\n    font-family: Inter;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 16.8px;\r\n    color: var(--white);\r\n  }\r\n\r\n  .pro-sidebar {\r\n    height: auto;\r\n\r\n    .pro-menu {\r\n      &:hover {\r\n        background-color: $submenu-bg-color !important;\r\n        .pro-icon-wrapper {\r\n          .pro-icon {\r\n            animation: none !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .pro-sidebar-inner {\r\n      .pro-sidebar-layout {\r\n        .pro-sidebar-header {\r\n          border-bottom: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-footer {\r\n    border-top: none;\r\n  }\r\n  .hr-sidebar {\r\n    border: 1px solid var(--white);\r\n    width: 90%;\r\n  }\r\n\r\n  .dashboardContainer {\r\n    display: flex;\r\n    background: linear-gradient(var(--white-1), var(--white-1), rgba(0, 0, 0, 0.1));\r\n  }\r\n\r\n  .dashboard {\r\n    height: auto;\r\n    display: flex;\r\n    background: linear-gradient(var(--white-1), var(--white-1), rgba(0, 0, 0, 0.1));\r\n  }\r\n\r\n  .homeSection {\r\n    width: auto;\r\n    height: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    animation: opacityMotion ease-out 0.5s;\r\n  }\r\n\r\n  .sidebar-version {\r\n    font-family: Inter;\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    font-size: 12px;\r\n    line-height: 17px;\r\n    text-align: center;\r\n    color: var(--white);\r\n  }\r\n\r\n  @keyframes opacityMotion {\r\n    0% {\r\n      opacity: 0%;\r\n    }\r\n    100% {\r\n      opacity: 100%;\r\n    }\r\n  }\r\n\r\n  .pro-sidebar .pro-menu .pro-menu-item {\r\n    font-size: 16.8px;\r\n    color: var(--white);\r\n  }\r\n  .sidebar-title {\r\n    font-family: Inter;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 28px;\r\n    color: var(--white);\r\n    margin-left: 1rem;\r\n  }\r\n\r\n  .btn-toggle {\r\n    cursor: pointer;\r\n    width: 35px;\r\n    height: 35px;\r\n    background: #353535;\r\n    color: #ffffff;\r\n    text-align: center;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 15px;\r\n    display: none;\r\n  }\r\n\r\n  .sidebar-btn-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    .sidebar-btn {\r\n      transition: width 0.3s;\r\n      width: 150px;\r\n      padding: 1px 15px;\r\n      border-radius: 40px;\r\n      background: rgba(255, 255, 255, 0.05);\r\n      color: #ffffff;\r\n      text-decoration: none;\r\n      margin: 0 auto;\r\n      height: 35px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      text-overflow: ellipsis;\r\n      overflow: hidden;\r\n      span {\r\n        margin-left: 5px;\r\n        font-size: 13px;\r\n      }\r\n      &:hover {\r\n        color: $highlight-color;\r\n      }\r\n    }\r\n  }\r\n\r\n  .collapsed {\r\n    .pro-menu-item {\r\n      &:hover {\r\n        background-color: #0064f8;\r\n        .pro-icon-wrapper {\r\n          .pro-icon {\r\n            animation: none !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .sidebar-btn {\r\n      display: inline-block;\r\n      line-height: 40px;\r\n      padding: 0;\r\n    }\r\n    .sidebar-title {\r\n      display: none !important;\r\n    }\r\n    .sidebar-user-label {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  main {\r\n    flex-grow: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n    height: 100vh;\r\n    header {\r\n      margin-top: 40px;\r\n      border-bottom: 1px solid #efefef;\r\n      h1 {\r\n        display: flex;\r\n        align-items: center;\r\n        transform: translateX(-20px);\r\n      }\r\n    }\r\n\r\n    footer {\r\n      margin-top: auto;\r\n      color: #888;\r\n      text-align: center;\r\n      a {\r\n        text-decoration: none;\r\n        color: #888;\r\n        &:hover {\r\n          text-decoration: underline;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .social-bagdes {\r\n    margin-top: 10px;\r\n    img {\r\n      margin: 5px;\r\n    }\r\n  }\r\n\r\n  .block {\r\n    display: flex;\r\n    margin-bottom: 24px;\r\n    font-size: 14px;\r\n    color: #545454;\r\n    > span {\r\n      margin-left: 10px;\r\n    }\r\n  }\r\n\r\n  &.rtl {\r\n    direction: rtl;\r\n    text-align: right;\r\n\r\n    header {\r\n      h1 {\r\n        transform: translateX(20px);\r\n      }\r\n    }\r\n    .block {\r\n      direction: rtl;\r\n      > span {\r\n        margin-left: 0;\r\n        margin-right: 10px;\r\n      }\r\n    }\r\n    .sidebar-btn-wrapper {\r\n      .sidebar-btn {\r\n        span {\r\n          margin-left: 0;\r\n          margin-right: 5px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 767.98px) {\r\n    overflow-x: hidden;\r\n    header {\r\n      h1 {\r\n        font-size: 24px;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    .pro-sidebar.md.collapsed {\r\n      left: 0;\r\n    }\r\n    .pro-sidebar.md {\r\n      left: 0;\r\n      position: relative;\r\n    }\r\n  }\r\n\r\n  // @media (min-width: 0px) and (max-width: 1400px) {\r\n  //   .pro-sidebar {\r\n  //     width: 99px;\r\n  //     min-width: 99px;\r\n  //   }\r\n  // }\r\n\r\n  // @media (max-width: $breakpoint-md) {\r\n  //   .btn-toggle {\r\n  //     display: flex;\r\n  //   }\r\n\r\n  //   &.rtl {\r\n  //     .btn-toggle {\r\n  //       margin-left: auto;\r\n  //     }\r\n  //   }\r\n  // }\r\n}\r\n\r\n.badge {\r\n  padding: 3px 6px;\r\n  font-size: 9px;\r\n  letter-spacing: 1px;\r\n  border-radius: 15px;\r\n  &.red {\r\n    color: #ffffff;\r\n    background: #d63030;\r\n  }\r\n  &.gray {\r\n    color: #ffffff;\r\n    background: #777777;\r\n  }\r\n  &.yellow {\r\n    color: #000000;\r\n    background: #ffd331;\r\n  }\r\n}\r\n\r\n.tooltip {\r\n  background-color: $submenu-bg-color;\r\n  opacity: 1 !important;\r\n  font-weight: 500 !important;\r\n}\r\n","@mixin break-point {\n  position: fixed;\n  left: -$sidebar-width;\n  &.collapsed {\n    left: -$sidebar-collapsed-width;\n  }\n  &.toggled {\n    left: 0;\n    .overlay {\n      display: block;\n    }\n  }\n  &.rtl {\n    left: auto;\n    right: -$sidebar-width;\n    &.collapsed {\n      left: auto;\n      right: -$sidebar-collapsed-width;\n    }\n    &.toggled {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n\n.pro-sidebar {\n  color: $sidebar-color;\n  height: 100%;\n  width: $sidebar-width;\n  min-width: $sidebar-width;\n  text-align: left;\n  transition: width, left, right, 0.3s;\n  position: relative;\n  z-index: 1009;\n  > .pro-sidebar-inner {\n    background: $sidebar-bg-color;\n    height: 100%;\n    position: relative;\n    z-index: 101;\n\n    > img.sidebar-bg {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n      position: absolute;\n      opacity: 0.3;\n      left: 0;\n      top: 0;\n      z-index: 100;\n    }\n\n    > .pro-sidebar-layout {\n      height: 100%;\n      overflow-y: auto;\n      overflow-x: hidden;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      z-index: 101;\n\n      .pro-sidebar-header {\n        border-bottom: 1px solid rgba($sidebar-color, 0.2);\n      }\n      .pro-sidebar-content {\n        flex-grow: 1;\n      }\n      .pro-sidebar-footer {\n        border-top: 1px solid rgba($sidebar-color, 0.2);\n      }\n      ul {\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n      }\n    }\n  }\n\n  .overlay {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(#000, 0.3);\n    z-index: 100;\n    display: none;\n  }\n\n  &.collapsed {\n    width: $sidebar-collapsed-width;\n    min-width: $sidebar-collapsed-width;\n  }\n\n  &.rtl {\n    text-align: right;\n    direction: rtl;\n  }\n\n  &.xs {\n    @media (max-width: $breakpoint-xs) {\n      @include break-point;\n    }\n  }\n  &.sm {\n    @media (max-width: $breakpoint-sm) {\n      @include break-point;\n    }\n  }\n  &.md {\n    @media (max-width: $breakpoint-md) {\n      @include break-point;\n    }\n  }\n  &.lg {\n    @media (max-width: $breakpoint-lg) {\n      @include break-point;\n    }\n  }\n  &.xl {\n    @media (max-width: $breakpoint-xl) {\n      @include break-point;\n    }\n  }\n  &.xxl {\n    @media (max-width: $breakpoint-xxl) {\n      @include break-point;\n    }\n  }\n}\n","%pro-item-prefix {\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 4px;\n    min-width: 4px;\n    height: 4px;\n    border: 1px solid $submenu-bg-color;\n    border-radius: 50%;\n    margin-right: 15px;\n    position: relative;\n    box-shadow: 1px 0px 0px $sidebar-color, 0px -1px 0px $sidebar-color, 0px 1px 0px $sidebar-color,\n      -1px 0px 0px $sidebar-color;\n  }\n}\n\n%text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pro-sidebar {\n  .pro-menu {\n    padding-top: 10px;\n    padding-bottom: 10px;\n\n    > ul {\n      > .pro-sub-menu {\n        > .pro-inner-list-item {\n          position: relative;\n          background-color: $submenu-bg-color;\n\n          > div > ul {\n            padding-top: 15px;\n            padding-bottom: 15px;\n          }\n        }\n      }\n    }\n    a {\n      text-decoration: none;\n      color: $sidebar-color;\n      &:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: transparent;\n      }\n      &:hover {\n        color: $highlight-color;\n      }\n    }\n    .pro-menu-item {\n      font-size: 15px;\n      &.active {\n        color: $highlight-color;\n      }\n\n      .suffix-wrapper {\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n      .prefix-wrapper {\n        display: flex;\n        margin-right: 5px;\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n\n      > .pro-inner-item {\n        position: relative;\n        display: flex;\n        align-items: center;\n        padding: 8px 35px 8px 20px;\n        cursor: pointer;\n\n        &:focus {\n          outline: none;\n          color: $highlight-color;\n        }\n        > .pro-icon-wrapper {\n          margin-right: 10px;\n          font-size: 14px;\n          width: $icon-size;\n          min-width: $icon-size;\n          height: $icon-size;\n          line-height: $icon-size;\n          text-align: center;\n          display: inline-block;\n\n          .pro-icon {\n            display: flex;\n            height: 100%;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n\n        > .pro-item-content {\n          flex-grow: 1;\n          flex-shrink: 1;\n\n          @extend %text-truncate;\n        }\n\n        &:hover {\n          color: $highlight-color;\n          .pro-icon-wrapper {\n            .pro-icon {\n              animation: swing ease-in-out 0.5s 1 alternate;\n            }\n          }\n        }\n      }\n\n      &.pro-sub-menu {\n        > .pro-inner-item {\n          &:before {\n            background: $sidebar-color;\n          }\n\n          > .pro-arrow-wrapper {\n            position: absolute;\n            right: 20px;\n            top: 50%;\n            transform: translateY(-50%);\n\n            .pro-arrow {\n              display: inline-block;\n              border-style: solid;\n              border-color: $sidebar-color;\n              border-width: 0 2px 2px 0;\n              padding: 2.5px;\n              vertical-align: middle;\n              transition: transform 0.3s;\n              transform: rotate(-45deg);\n            }\n          }\n        }\n\n        &.open {\n          > .pro-inner-item {\n            &:before {\n              background: transparent !important;\n            }\n            > .pro-arrow-wrapper {\n              .pro-arrow {\n                transform: rotate(45deg);\n              }\n            }\n          }\n        }\n\n        .pro-inner-list-item {\n          padding-left: $submenu-indent;\n\n          .pro-inner-item {\n            padding: 8px 30px 8px 15px;\n\n            > .pro-icon-wrapper {\n              background: none;\n              width: auto;\n              min-width: auto;\n              height: auto;\n              line-height: auto;\n            }\n          }\n        }\n      }\n    }\n\n    &:not(.inner-submenu-arrows) {\n      .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {\n        display: none;\n      }\n    }\n    &.submenu-bullets {\n      .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {\n        @extend %pro-item-prefix;\n      }\n    }\n\n    &.shaped {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            background-color: $icon-bg-color;\n          }\n        }\n      }\n    }\n\n    &.square {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 0;\n          }\n        }\n      }\n    }\n    &.round {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 4px;\n          }\n        }\n      }\n    }\n    &.circle {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 50%;\n          }\n        }\n      }\n    }\n  }\n\n  // styling when the sidebar is collapsed\n\n  &.collapsed {\n    .pro-menu {\n      > ul {\n        > .pro-menu-item {\n          > .pro-inner-item {\n            > .suffix-wrapper,\n            > .prefix-wrapper {\n              opacity: 0;\n            }\n          }\n          > .pro-inner-list-item {\n            background-color: $submenu-bg-color-collapsed;\n            z-index: 111;\n          }\n          position: relative;\n          &::before {\n            content: '';\n            display: inline-block;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            cursor: pointer;\n          }\n          &.pro-sub-menu {\n            position: relative;\n\n            > .pro-inner-item {\n              pointer-events: none;\n\n              > .pro-arrow-wrapper {\n                display: none;\n              }\n            }\n            > .pro-inner-list-item {\n              height: auto !important;\n              position: fixed;\n              visibility: hidden;\n              min-width: 220px;\n              max-width: 270px;\n              background-color: transparent;\n              max-height: 100%;\n              padding-left: 3px;\n              &.has-arrow {\n                padding-left: 10px;\n              }\n              > .popper-inner {\n                max-height: 100vh;\n                overflow-y: auto;\n                background-color: $submenu-bg-color-collapsed;\n                padding-left: 20px;\n                border-radius: 4px;\n              }\n            }\n            &:hover {\n              > .pro-inner-list-item {\n                transition: visibility, transform 0.3s;\n                visibility: visible;\n              }\n              .pro-icon-wrapper {\n                .pro-icon {\n                  animation: swing ease-in-out 0.5s 1 alternate;\n                }\n              }\n            }\n\n            .pro-inner-list-item {\n              .pro-sub-menu-item,\n              .pro-inner-item {\n                padding: 8px 30px 8px 5px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // styles for rtl\n  &.rtl {\n    .pro-menu {\n      .pro-menu-item {\n        .prefix-wrapper {\n          margin-right: 0;\n          margin-left: 5px;\n        }\n        > .pro-inner-item {\n          padding: 8px 20px 8px 35px;\n          > .pro-icon-wrapper {\n            margin-right: 0;\n            margin-left: 10px;\n          }\n        }\n\n        &.pro-sub-menu {\n          > .pro-inner-item {\n            > .pro-arrow-wrapper {\n              right: auto;\n              left: 20px;\n              .pro-arrow {\n                transform: rotate(135deg);\n              }\n            }\n          }\n          &.open {\n            > .pro-inner-item {\n              > .pro-arrow-wrapper {\n                .pro-arrow {\n                  transform: rotate(45deg);\n                }\n              }\n            }\n          }\n\n          .pro-inner-list-item {\n            padding-left: 0;\n            padding-right: $submenu-indent;\n\n            .pro-inner-item {\n              padding: 8px 15px 8px 30px;\n              &:before {\n                margin-right: 0;\n                margin-left: 15px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // styles for rtl and collapsed\n    &.collapsed {\n      .pro-menu {\n        > ul {\n          > .pro-menu-item {\n            &.pro-sub-menu {\n              > .pro-inner-list-item {\n                padding-left: 0;\n                padding-right: 3px;\n                &.has-arrow {\n                  padding-right: 10px;\n                }\n                > .popper-inner {\n                  padding-left: 0;\n                  padding-right: 20px;\n                }\n              }\n\n              .pro-inner-list-item {\n                .pro-sub-menu-item,\n                .pro-inner-item {\n                  padding: 8px 5px 8px 30px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","$sidebar-bg-color: #1d1d1d !default;\n$sidebar-color: #adadad !default;\n$sidebar-width: 270px !default;\n$sidebar-collapsed-width: 80px !default;\n$highlight-color: #d8d8d8 !default;\n$submenu-bg-color: #2b2b2b !default;\n$submenu-bg-color-collapsed: #2b2b2b !default;\n$icon-bg-color: #2b2b2b !default;\n$icon-size: 35px !default;\n$submenu-indent: 24px !default;\n\n$breakpoint-xs: 480px !default;\n$breakpoint-sm: 576px !default;\n$breakpoint-md: 768px !default;\n$breakpoint-lg: 992px !default;\n$breakpoint-xl: 1200px !default;\n$breakpoint-xxl: 1600px !default;\n",".popper-arrow {\n  position: absolute;\n  z-index: -1;\n  width: 0;\n  height: 0;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.popper-element[data-popper-placement^='left'] > .popper-arrow {\n  right: 0;\n  border-right: 7px solid $submenu-bg-color-collapsed;\n}\n\n.popper-element[data-popper-placement^='right'] > .popper-arrow {\n  left: 0;\n  border-left: 7px solid $submenu-bg-color-collapsed;\n}\n",".react-slidedown {\n  height: 0;\n  transition-property: none;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n}\n\n.react-slidedown.transitioning {\n  overflow-y: hidden;\n}\n\n.react-slidedown.closed {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
